import { gEnums } from "global/enums/globalEnums";
import { useMemo } from "react";
import { _matchDisplayTypes } from "../elements/matches/MatchContent";

export const useMatchScheduleOptions = ({ matchScheduleDisplayType }) => {

  const msdts = gEnums.matchScheduleDisplayTypes

  let _matchScheduleDisplayType = matchScheduleDisplayType ? matchScheduleDisplayType : msdts.clickedDates

  const getMatchDisplayType = (msdt) => {
    switch (msdt) {
      case msdts.levelDates:
      case msdts.levelDates:
      case msdts.levelTabsFull:
      case msdts.currentMatches:
      case msdts.missing:
      case msdts.matchDay:
      case msdts.pendingMatches:
        return _matchDisplayTypes.levelMatches;

      case msdts.scoreboard:
        return _matchDisplayTypes.scoreboard;

      case msdts.teamSchedule:
      case msdts.teamScheduleMini:
      case msdts.teamScheduleRemaining:
      case msdts.nextTeamMatch:
      case msdts.direct:
      case msdts.teamsCommon:
        return _matchDisplayTypes.teamMatches;

      case msdts.levelOverviewMatches:
        return _matchDisplayTypes.levelOverviewMatches
      default:
      // nothing
    }
  }

  const getMatchDisplayOptions = (msdt) => {
    const _matchDisplayOptions = {
      showDataHeader: false,
      showLevelHeader: false,
      showMatchFilter: false,
      showCalendar: false,
      showGotoToday: false,
      showScheduleHeader: false,
      showLegend: false,
      showDateList: false,
      showMatchChanges: true,
      showMatchHeader: false,
    }

    switch (msdt) {
      case msdts.scoreboard:
        _matchDisplayOptions.showDataHeader = true
        break;
      default:
      // nothing
    }

    switch (msdt) {
      case msdts.levelTabsFull:
        _matchDisplayOptions.showLegend = true
        _matchDisplayOptions.showMatchHeader = true
        _matchDisplayOptions.showGotoToday = true
        break;
      default:
      // nothing
    }

    switch (msdt) {
      case msdts.missing:
      case msdts.currentMatches:
      case msdts.levelTabsFull:
      case msdts.scoreboard:
      case msdts.matchDay:
        _matchDisplayOptions.showLevelHeader = true
        _matchDisplayOptions.showScheduleHeader = true
        break;
      case msdts.teamSchedule:
      case msdts.teamScheduleMini:
        _matchDisplayOptions.showMatchFilter = true
        break;
      default:
      // nothing
    }

    switch (msdt) {
      case msdts.currentMatches:
        _matchDisplayOptions.showMatchChanges = true
        break;
        break;
      default:
      // nothing
    }

    return _matchDisplayOptions
    // const _matchScheduleInfo = {
    //   _matchDisplayType,
    //   _matchDisplayOptions,
    // }
  }


  const matchScheduleOptions = useMemo(() => {

    const _matchDisplayType = getMatchDisplayType(_matchScheduleDisplayType);
    const _matchDisplayOptions = getMatchDisplayOptions(_matchScheduleDisplayType)

    const _matchScheduleInfo = {
      _matchDisplayType,
      _matchDisplayOptions,
    }

    return _matchScheduleInfo

  }, [_matchScheduleDisplayType]);


  return matchScheduleOptions

};